import React from 'react'
import {ColorCodingOption} from "../../../app/home/my-work/common/model/@type";
import {defaultColorCodingOptions} from "../../../app/home/my-work/common/model/@const";

export enum CardViewLayout {
    COLOR_CODING_BORDER_LEFT    = 'left',
    COLOR_CODING_BORDER_TOP     = 'top',
    COLOR_CODING_NONE           = 'none',
    COLOR_CODING_FILL           = 'fill',
}

type Props = {
    value       : any,
    options?    : ColorCodingOption[],
    disabled?   : boolean,

    onChange    : any
}

// const debug = "CardViewSelector"
const debug = false

export default function CardViewSelector(props: Props) {

    const onClick = (option: ColorCodingOption) => {
        if (props.disabled) return
        props.onChange(option)
    }

    const options: ColorCodingOption[] = _.get(props, 'options', defaultColorCodingOptions)

    debug && console.log(debug, 'render', props.value, options)

    return (
        <div className="ui5-card-view-selector">
            { _.map(options, (option, key)=> {
                const classes = Classes('card', {
                    selected: props.value === option.value
                })

                const style = {
                    backgroundImage : 'url('+option.img+')'
                }

                return (
                    <div key={key} className={classes} onClick={()=>{onClick(option)}}>
                        <div className="preview" style={style}/>
                        {(props.value === option.value) &&
                            <div className="ui5-ico-selected s-15"/>}
                    </div>
                )
            })}
        </div>
    )
}
